module.exports = __webpack_public_path__ + "static/media/squareMatBrown95.a55eb54c.png";